import { render, staticRenderFns } from "./ProfileMessage.vue?vue&type=template&id=00a0d5a6&"
import script from "./ProfileMessage.vue?vue&type=script&lang=js&"
export * from "./ProfileMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports